export const contentTableConfig = {
  propList: [
    {
      prop: 'operationType',
      label: 'log.operation-type'
    },
    {
      prop: 'message',
      label: 'log.message'
    },
    {
      prop: 'ipAddress',
      label: 'log.ip-address'
    },
    {
      prop: 'location',
      label: 'log.location'
    },
    {
      prop: 'createdTime',
      slotName: 'formatZeroTime',
      label: 'common.app-creation-time'
    }
  ],
  showIndexColumn: true,
  showSelectColumn: true
}
